import { queryOptions } from '@tanstack/react-query';
import { getBOM } from '~/pages/BillOfMaterials/api/bom.api';
import { BillOfMaterialsModel } from '~/pages/BillOfMaterials/models/BillOfMaterialsModel';
import {
  BOMParameters,
  CreateBomParametersModel,
} from '~/pages/BillOfMaterials/models/CreateBomParametersModel';
import { SystemModel } from '~/shared/models/system/SystemModel';

export const bomQuery = (
  bomParameters: BOMParameters,
  currentSystem: SystemModel,
) =>
  queryOptions({
    queryKey: ['statistics', bomParameters],
    queryFn: async () => {
      const response = await getBOM(
        CreateBomParametersModel.toGetBomRequest(
          currentSystem.name,
          bomParameters,
        ),
      );

      return new BillOfMaterialsModel(response, currentSystem);
    },
  });
